import { isAndroid } from "react-device-detect"

export const containerResize = (w, h, container) => {
  container.x = w / 2
  if (w < 768) {
    // if (isAndroid) {
    // container.y = 0
    // } else {
    container.y = 87 + 230
    // }
    container.scale.set(0.6)
  }
  if (w >= 768 && w < 1024) {
    container.y = 120 + 300
    container.scale.set(0.8)
  }

  const betsWidth = ((w - 80) * 3) / 13
  if (w >= 1024) {
    container.y = 122 + 480
    container.scale.set(1)
    if (h < 920 && h >= 720) {
      container.y = 420
      container.scale.set(0.9)
    }
    if (h < 720 && h >= 640) {
      container.y = 350
      container.scale.set(0.8)
    }
    if (h < 640) {
      container.y = 300
      container.scale.set(0.6)
    }
    if (h < 580) {
      container.y = 250
      container.scale.set(0.6)
    }

    if (betsWidth > 400) {
      container.x = (w - 400) / 2 + 400
      return
    }
    if (betsWidth < 300) {
      container.x = (w - 300) / 2 + 300
      return
    }
    container.x = (w - betsWidth) / 2 + betsWidth
  }
}

function getStarsOffset(isLoading, isJackpot) {
  let w = document.body.clientWidth
  let h = document.body.clientHeight
  let y = 0
  if (w < 768) {
    if (isLoading && isAndroid && !isJackpot) {
      y = 200
      // alert("android")
    } else {
      y = -152
    }
    // if (isAndroid && isLoading) {
    // y = 200
    // alert("android")
    // } else {
    // y = isLoading ? 0 : -152
    // }
    // alert('w < 768')
  }
  if (w >= 768 && w < 1024) {
    y = -177
  }

  if (w >= 1024) {
    y = -200
    if (h < 640) {
      y = -150
    }
    if (h < 720 && h >= 640) {
      y = -150
    }
    if (h < 920 && h >= 720) {
      y = -150
    }
  }
  return y
}

export const resizeHandler = (app, container, isLoading, isJackpot) => {
  const w = document.body.clientWidth
  const h = document.body.clientHeight
  app.renderer.autoResize = true
  app.renderer.resize(w, h)
  const starContainer = app.stage.getChildByName("starContainer")
  containerResize(w, h, container)
  if (starContainer != null) {
    starContainer.x = container.x
    starContainer.y = container.y + getStarsOffset(isLoading, isJackpot)
  }
}

export const getY = () => {
  let w = document.body.clientWidth
  let h = document.body.clientHeight
  var y = 0
  if (w < 768) {
    y = -152
  }
  if (w >= 768 && w < 1024) {
    y = -177
  }

  if (w >= 1024) {
    y = -200
    if (h < 640) {
      y = -150
    }
    if (h < 720 && h >= 640) {
      y = -150
    }
    if (h < 920 && h >= 720) {
      y = -150
    }
  }
  return y
}
